import { FunctionComponent } from 'react'
import { Container, Box, Grid, ListItem, List } from '@mui/material'
import { NavItem, splittedNavItems } from './nav-items'
import styled from '@emotion/styled'
import { useNavigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
const Logo = require('assets/images/new_logo.png')

const StyledLink = styled(ListItem)({
  fontWeight: '400',
  fontSize: '14px',
  lineHeight: '20px',
  color: '#b7bbc2',
  padding: 0,
  cursor: 'pointer !important',
  '&:first-of-type': {
    fontWeight: '500',
    color: '#fff',
    cursor: 'default',
  },
})

export const Footer: FunctionComponent = () => {
  const navigate = useNavigate()
  const { t } = useTranslation()

  return (
    <Box
      bgcolor="#1e2023"
      sx={{
        padding: {
          xs: '24px 0',
          md: '72px 0',
        },
        minHeight: '340px',
      }}
    >
      <Container maxWidth="lg">
        <Grid
          gap={1}
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
          }}
          container
        >
          <Grid item xs={2}>
            <Box sx={{ cursor: 'pointer' }} onClick={() => navigate('/')}>
              <img width="150px" src={Logo} alt="Logo" />
            </Box>
          </Grid>
          <Grid item xs={9}>
            <Grid container>
              <Grid item xs={6} md={4}>
                {splittedNavItems.firstPart.map((nav: NavItem) => {
                  return (
                    <List key={nav.id}>
                      <StyledLink onClick={() => navigate(nav.path)}>
                        {t(nav.id)}
                      </StyledLink>
                    </List>
                  )
                })}
              </Grid>
              <Grid item xs={6} md={4}>
                {splittedNavItems.secondPart.map((nav: NavItem) => {
                  return (
                    <List sx={{ cursor: 'pointer' }} key={nav.id}>
                      <StyledLink onClick={() => navigate(nav.path)}>
                        {t(nav.id)}
                      </StyledLink>
                    </List>
                  )
                })}
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Container>
    </Box>
  )
}
